import React from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, TableCell } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

export default function SortTableCell({ children }: Props) {
  return (
    <TableCell>
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' }}>
        {children}
        <KeyboardArrowDownIcon sx={{ color: 'text.secondary', fontSize: 16 }} />
      </Box>
    </TableCell>
  );
}
